<template>
  <div>
    <base-info v-if=" conditionList && formDataCopy  "
               :regionListOri="regionList"
               :formData="formDataCopy"
               :conditionList="conditionList"
               ref="baseinfo"

    ></base-info>
    <save-and-cancel @save="save" @cancel="cancel" v-p="{api:'project/updateBaseInfo'}">
    </save-and-cancel>
  </div>
</template>
<script>

  import SaveAndCancel from 'components/SaveAndCancel/index'
  import BaseInfo from '../../components/BaseInfo'
  import {getBaseInfoByProjectId, updateBaseInfo} from "../../../../../api/project";
  import {deepClone} from "../../../../../utils/format";
  import {addCondition} from "../../../../../api/project";
  import {projectregion} from "../../../../../api/project";
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    name: "BaseUpdate",
    props: {
      projectFid: {
        type: String,
        default: null
      },

    },
    components: {
      SaveAndCancel,
      BaseInfo
    },
    data() {
      return {
        regionList:[],
        formData: null,
        formDataCopy: null,
        conditionList:null,
      }
    },
    watch: {
      formData(value) {
        this.formDataCopy = deepClone(value)
      },
      projectFid(value) {
        if (!value) {
          return
        }
        this.getBaseInfoByProjectId()
      }
    },
    methods: {
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)
      },
      getBaseInfoByProjectId() {
        var params = {
          "projectFid": this.projectFid,
          "houseTypeNum": 0,
          "houseNum": 0
        }

        getBaseInfoByProjectId(params).then(res => {
          this.formData = res.data
        })
      },
      save() {
        this.formDataCopy.projectCompanyName = ''
        if(!this.formDataCopy.projectAddress){
          this.formData.addressValid=true
        }
        this.$refs['baseinfo'].$refs['form'].validate(bool => {
          if (bool) {
            this.formDataCopy.projectCompanyName = this.$refs['baseinfo'].projectCompanyMap[this.formDataCopy.projectCompanyCode + '']
            this.formDataCopy.projectContractBegin = this.format(this.formDataCopy.dateList[0])
            this.formDataCopy.projectContractEnd = this.format(this.formDataCopy.dateList[1])
            this.formDataCopy.projectOpeningTime=this.format(this.formDataCopy.projectOpeningTime)
            this.formDataCopy.projectDecorateTime=this.format(this.formDataCopy.projectDecorateTime)

            updateBaseInfo(this.formDataCopy).then(res => {
                this.$Message.success('信息修改成功')
            }).catch(error=>{})
          }
          else {
            this.$Message.info('请检查填写内容！')
            return
          }
        })
      },
      cancel() {
        this.formDataCopy = deepClone(this.formData)
        this.$refs['baseinfo'].$refs['form'].resetFields()

      }
    },
    created(){
      addCondition().then(res => {
        this.conditionList=res.data
      })
      var params = {
        "projectFid": this.projectFid,
        "houseTypeNum": 0,
        "houseNum": 0
      }
      getBaseInfoByProjectId(params).then(res2 => {
        var params2={
          cityCode:res2.data.projectCityCode
        }
        projectregion(params2).then(res3=>{
          this.regionList=res3.data.region
          res2.data['dateList']=[res2.data.projectContractBegin,res2.data.projectContractEnd]
          res2.data['addressValid']=false
          this.formData = res2.data
        })

        // this.formData = res2.data
      })
    }
  }

</script>

<style scoped>
  .map-container {
    width: 40%;
    height: 180px;
    /*background-color: #6d7380;*/
  }

  .input-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .input-short {
    width: 100px;
  }

</style>
